import { isAlticeStore } from "../stores/isAlticeStore";
export function detectAltice() {
    if (typeof window !== 'undefined') {
        isAlticeStore.set(window.location.href.includes('altice'));
    }
}
